// hooks/useWebAuthn.js
import { useState } from 'react';
import { getRegistrationOptions, registerBiometric } from '../actions/biometric-action';
import { useDispatch } from 'react-redux';
import { host } from '../config';
import { bioregistrationUrl } from '../actions/const';
import { toast } from 'react-toastify';
import { BIOMETRIC_REGISTRATION_ENABLED } from '../actions/types';
import {
  create,
  parseCreationOptionsFromJSON,
} from "@github/webauthn-json/browser-ponyfill";

const useWebAuthn = () => {
  const dispatch = useDispatch();
  const [isRegistering, setIsRegistering] = useState(false);

  const register = async () => {
    setIsRegistering(true);
    let attResp;
    try {
      const options = await dispatch(getRegistrationOptions());
      const optionsJson = await parseCreationOptionsFromJSON({publicKey:options});
      attResp  = await create(optionsJson)
      const verificationResp = await dispatch(registerBiometric(attResp));
      if (!verificationResp.code === 200) {
        throw new Error('Failed to register biometric');
      }
      dispatch({
        type: BIOMETRIC_REGISTRATION_ENABLED,
        payload: true,
      });
      toast.success("Biometric registration completed");
    } catch (error) {
      toast.error(`Error : ${error.message}`);
    } finally {
      setIsRegistering(false);
    }
  };
  const unregister = async () => {
    setIsRegistering(true);
    let attResp;
    try {
      const options = await dispatch(getRegistrationOptions());
      const optionsJson = parseCreationOptionsFromJSON(options);
      attResp  = await create(optionsJson)
      const verificationResp = await dispatch(registerBiometric(attResp));
      if (!verificationResp.code === 200) {
        throw new Error('Failed to register biometric');
      }
      toast.success("Biometric registration completed");
    } catch (error) {
      toast.error(`Error : ${error.message}`);
    } finally {
      setIsRegistering(false);
    }
  };

  return { register, isRegistering };
};

export default useWebAuthn;
